import React, { useEffect, useState, useContext } from 'react'
import downArrow from '../../Assets/Path 8 Copy.png'
import upArrow from '../../Assets/Path 8.png'
import { Nav, NavItem } from "reactstrap";
import { NavLink } from "react-router-dom";
import { Container, Row, Col, Card, CardText, Collapse } from "reactstrap";
import { globalState } from '../../GlobalState/globalState';

import '../../CSS/FAQ.css'

const FaqConsumerMobile = () => {
    let [state, dispatch] = useContext(globalState)
    let [faqs_profileRegistration, setFaqs_profileRegistration] = useState(
        [
            {
                id: 1,
                ques: 'How do I download the Slash app?',
                ans: (
                    <div>
                          You can follow below mentioned steps for downloading Slash App on iOS devices –
                        <ol type="a">
                            <li>You can download and install the Slash App on devices with iOS 10 and newer. Visit App store on your iPhone.</li>
                            <li>Select Search from the menu, type Quickfind Inc in the search bar, then tap Search.</li>
                            <li>Select the Slash icon and Tap “Get” your device may require you to enter your App Store password.</li>
                            <li>When download is complete, “Get” will change to “Install”. Tap “Install” to start the installation.</li>
                            <li>When the installation is complete, “Install” will change to “Open”. Tap on it.</li>
                            <li>In the Slash app, click on “Register” to create a new account or click on “Login” if you already have an account.</li>
                        </ol>
                        You can download and install the Slash app on android devices play store version 8 & above. Head to the Google play store and follow these steps:
                        <ol type="a">
                            <li>Tap the Google Play icon.</li>
                            <li>Tap the search bar, type Quickfind Inc and then tap Search.</li>
                            <li>Select the Slash icon and tap “Install”.</li>
                            <li>After app installation is complete, tap “Open”.</li>
                            <li>In the Slash app, click on “Register” to create a new account or click on “Login” if you already have an account.</li>
                        </ol>
                    </div>
                    
                )
            },
            {
                id: 2,
                ques: 'How do I register myself?',
                ans: (
                    <div>
                        To register yourself follow below mentioned steps - 
                        <ol type="a">
                            <li>Open the Slash app and tap on “Profile Icon” on the top right of the Home page.</li>
                            <li>Click on the “Login/Register” tab and click on register at the bottom of the “Login” page.</li>
                            <li>Enter your Name, Phone Number.</li>
                            <li>A Verification Code will be sent to your Mobile Number.</li>
                            <li>Enter verification Code to verify your Mobile Number.</li>
                            <li>You are successfully registered. Now Login with your mobile number explore Services.</li>
                        </ol>
                        You can also register while booking any service:
                        <ol type="a">
                            <li>Select any Service as a Guest User.</li>
                            <li>Before buying a booking you will be asked to mobile number.</li>
                            <li>Enter and tap on “continue”.</li>
                            <li>Click on verification you will become a registered Customer.</li>
                        </ol>
                    </div>
                )
            },
            {
                id: 3,
                ques: 'Can I buy an Service as a Guest User?',
                ans: (
                    <div>
                        You can follow below steps to buy any Service as a guest user –
                        <ol type="a">
                            <li>Select any Service and tap on the “Buy now” option.</li>
                            <li>Before buying a booking, you will be asked to enter email id and password (optional).</li>
                            <li>Provide your email id and complete the payment.</li>
                            <li>Booking details will be sent to your email address.</li>
                        </ol>
                    </div>
                )
            },
            {
                id: 4,
                ques: 'Can I register using only email?',
                ans: (
                    <div>
                        No. A valid mobile number is mandatory for registration. Email address is optional and can be added or updated anytime from your profile. 
                    </div>
                )
            },
            {
                id: 5,
                ques: 'How can I verify/update my Mobile Number?',
                ans: (
                    <div>
                        You can verify/update your mobile number following below steps -
                        <ol type="a">
                            <li>Visit your profile and click on the edit icon on the top right corner.</li>
                            <li>Change your “Mobile number” and click on “Update”.</li>
                            <li>Click on send to get verification code sent to your number.</li>
                            <li>Enter the verification code and click on verify.</li>
                        </ol>
                    </div>
                )
            },
            {
                id: 6,
                ques: 'How can I verify/update my email?',
                ans: (
                    <div>
                        You can follow below mentioned steps to change your email address -
                        <ol type="a">
                            <li>Visit your profile and click on “Edit icon” on the top right corner.</li>
                            <li>Now click on the “Change email” tab on business detail page.</li>
                            <li>Enter the new email address and click on “Submit”.</li>
                            <li>Enter the verification code sent to your new email address and click on “Verify”.</li>
                            <li>Your new email address will be updated successfully.</li>
                        </ol>
                    </div>
                )
            },
            {
                id: 7,
                ques: 'How can I update my name?',
                ans: 'To edit your name visit your profile and click on “Edit icon” on the top right corner. Enter your name in the input field and click on update.'
            },
            {
                id: 8,
                ques: 'How can I refer a friend?',
                ans: (
                    <div>
                        Open the Profile tab from the bottom-right corner and tap Refer a Friend and copy the referral code or tap on refer customer/ refer professional.  You can refer both customers and professionals. Earn 100 Coins when your referred customer completes their first booking, and 200 Coins when your referred professional completes their first service.
                        
                    </div>
                )
            },
            {
                id: 9,
                ques: 'How do I log out?',
                ans: (
                    <div>
                        To logout from your profile, follow the steps below:
                        <ol type="a">
                            <li>Go to your profile.</li>
                            <li>Click on logout in the menu.</li>
                            <li>You will be successfully logged out from your account.</li>
                        </ol>
                    </div>
                )
            },
            {
                id: 10,
                ques: 'How can I share the app link with my friend?',
                ans: 'Go to your profile and click on the share icon at the top right.'
            }

        ]
    )
    let [faqs_bookingCancellation, setFaqs_bookingCancellation] = useState(
        [
            {
                id: 1,
                ques: 'How do I find Services?',
                ans: (
                    <div>
                        To find Services follow below steps -
                        <ol type="a">
                            <li>Enter the location (city name or specific address) in the search bar on Home page. By default, your current location is used to find Services near to you.</li>
                            <li>You may add filters to shortlist your options of services. You can select multiple subcategories. Set the date and time on which you want to book.</li>
                            <li>Select Price range, distance and ratings to narrow down your search as per your preferences.</li>
                            <li>For better experience you can also sort the list of Professionals as per Price, Distance, ratings and Discount.</li>
                        </ol>
                    </div>
                )
            },
            {
                id: 2,
                ques: 'How do I locate the Professional on the Map?',
                ans: (
                    <div>
                        To register yourself follow below mentioned steps -
                        <ol type="a">
                            <li>Click on the Map icon on top right corner of home page.</li>
                            <li>Balloon icon will show you the Professionals available in the area and the discount offered by them on their services.</li>
                            <li> You can click on each of these balloon icons to know more about the Professional.</li>
                            <li> Tap on the display card at the bottom of the map which appears once you tap on the balloon.</li>.
                            <li> You will be redirected to the Professional detail page which will show all offers available from the Professional.</li>
                        </ol>
                    </div>
                )
            },
            {
                id: 3,
                ques: 'How can I filter offers based on my preferences?',
                ans: (
                    <div>
                        To filter offers go to home page and follow below steps –
                        <ol type="a">
                            <li>Click on filter icon at the bottom left of the page.</li>
                            <li>Apply your choice of filters based on subcategory, Price Range, Distance, Ratings, Date and Time to narrow the search.</li>
                        </ol>
                    </div>
                )
            },
            {
                id: 4,
                ques: 'How can I see all the offers from a single professional?',
                ans: (
                    <div>
                        To view all offers available with a single professional, click on the offer display card of any professional. You will be redirected to the Professional detail page which will have the list of all offers. Now you can click on each offer to view details.
                    </div>
                )
            },
            {
                id: 5,
                ques: 'How do I book a service ?',
                ans: (
                    <div>
                        To book a service, follow these steps  –
                        <ol type="a">
                            <li>Go to the Home page and tap on the category or service you want.</li>
                            <li>Browse the available services, along with their price and duration.</li>
                            <li>Select a service and customize it by choosing the options you need(if available).</li>
                            <li>Choose your preferred date and time, then tap Proceed.</li>
                            <li>On the Checkout page, apply a coupon(if applicable) and tap Proceed to Pay.</li>
                            <li>Complete the payment.Once your booking is confirmed, you can view it under My Bookings → Upcoming.</li>
                        </ol>
                    </div>
                )
            },
        
            
            {
                id: 6,
                ques: 'Can I book multiple services ? ',
                ans: (
                    <div>
                       Yes, you can book any number of services based on the slot availability for the selected date and time.

                    </div>
                )
            },
            {
                id: 7,
                ques: 'Where can I check my booking details?',
                ans: (
                
                        <div>
                            Go to My Bookings from the bottom navigation. Here, you ll find your bookings under Upcoming, Past, and Cancelled tabs. Open any booking to view its details, including the service, date & time, professional details, address, payment status, and booking updates.
                        </div>
                )
            },
            {
                id: 8,
                ques: 'How can I cancel my booking?',
                ans: (
                    <div>
                        As a registered user you can follow below steps to cancel your booking if cancellation is allowed for the service you booked –
                        <ol>
                            <li>Go to My Bookings → Upcoming.</li>
                            <li>Open the booking you want to cancel.</li>
                            <li>Scroll to the bottom of the Booking Details page and tap Cancel Booking.</li>
                            <li>Confirm your cancellation.</li>
                        </ol>
                   
                        <ol>
                            Please note: Cancellation charges may apply based on how much time is left before your scheduled booking. Any applicable charges will be deducted from your refund as per our cancellation policy.
                        </ol>
                    </div>
                )
            },
            {
                id: 9,
                ques: 'What is booking Validation?',
                ans: (
                    <div>
                        In the booking detail page of any upcoming booking you will find a PIN number/ QR code. After the service has been delivered by the Service Professional, this PIN number/QR code needs to be shared with them to validate the booking. This step ensures release of payment to the professional for providing the service you booked with them.
                    </div>
                )
            },
            {
                id: 10,
                ques: 'Should I provide a booking pin and QR code both at the time of booking validation?',
                ans: 'Either the PIN number or QR code can be used to validate your bookings.'
            }

        ],

    )

     let [faqs_paymentRefund, setFaqs_paymentRefund] = useState(
    
            [
                {
                    id: 1,
                    ques: 'What are the payment methods available on the app?',
                    ans: (
                        <div>
                            As of now, you can use either Debit or credit card to complete the payment during booking of any offer.
                        </div>
                    )
                },
                {
                    id: 2,
                    ques: 'How secure is my credit card/debit card info?',
                    ans: (
                        <div>
                            Our payments are powered and secured by Stripe to keep your information safe. We don’t store your payment method details with us.
                        </div>
                    )
                },
                {
                    id: 3,
                    ques: 'Where can I see my payments done against any booking?',
                    ans: (
                        <div>
    
                            <ol type="a">
                                <li>To view all your payment transactions visit your “Profile”.</li>
                                <li>Click on “Payment transactions”.</li>
                                <li>You can view all your transactions under “Payments” tab.</li>
                            </ol>
                        </div>
                    )
                },
                {
                    id: 4,
                    ques: 'Where can I see my refunds?',
                    ans: (
                        <div>
                            <ol>
                                <li>To view refunds, visit your “Profile”.</li>
                                <li>Click on “Payment transactions”.</li>
                                <li>You can view all refund details under “Refunds” tab.</li>
                            </ol>
                        </div>
                    )
                },
                {
                    id: 5,
                    ques: 'Why have I not received my refund amount?',
                    ans: (
                        <div>
                            After cancellation, the outstanding refund amount will be credited to your payment method in 5-7 business days. In case you haven’t received the refund in 5-7 business days, please email to support@goslash.com.
                        </div>
                    )
                },
                {
                    id: 6,
                    ques: 'I have missed an appointment. Will I receive a refund?',
                    ans: (
                        <div>
                            If you have missed your appointment, you won’t be eligible for a refund. You can reach out to us through email (support@goslash.com) for any booking related queries.
    
                        </div>
                    )
                },
                {
                    id: 7,
                    ques: 'My transaction timed out while booking?',
                    ans: (
                        <div>
                            Transaction timeout happens due to Inactivity or slow internet while booking. If the amount is debited, it will be credited to the source account within 5-7 business days.
                        </div>
                    )
                },
                {
                    id: 8,
                    ques: 'While booking, my credit card/debit card transaction failed?',
                    ans: (
                        <div>
                            <div>
                                Transactions may fail due to incorrect card details submitted while making payments. Kindly try again with correct details.
                            </div>
                            <div>
                                Please note: If the amount was debited from your account it will be credited back within 5-7 business days.
                            </div>
                        </div>
                    )
                },
                {
                    id: 9,
                    ques: 'I have saved my card. Where can I see it?',
                    ans: (
                        <div>
                            To view your saved cards details, visit your profile and click on saved cards.
                        </div>
                    )
                },
                {
                    id: 10,
                    ques: 'Can I save more than one card details for future payments?',
                    ans: (
                        <div>
                            In order to add another card details, follow the below steps –
                            <ol>
                                <li>Choose your desired offer from the list and click on “Buy Now” tab.</li>
                                <li>While going through the process of booking an offer you will land on the payment page.</li>
                                <li>Now you will be prompted to pay through an already saved card or you can add another card detail for payment and click on “Save card for future payments”.</li>
                                <li>You can see the newly added card in “Saved Card” page in “Profile” section.</li>
                            </ol>
                        </div>
                    )
                },
                
    
            ],
        )

    
        let [faqs_couponReferral, setFaqs_couponReferral] = useState(
    
            [
               
                {
                    id: 3,
                    ques: 'How can I refer to my friend?',
                    ans: (
                        <div>
                            You can follow below mentioned steps for referring your friend -
                            <ol type="a">
                                <li>'Go to Profile from the bottom-right corner and tap Refer & Earn. You can refer both customers and professionals.</li>
                            </ol>
                            You can also refer Professionals by clicking on “Refer them” below the “Invite Now” button.
                        </div>
                    )
                },
                {
                    id: 4,
                    ques: 'How can my friend use the referral code?',
                    ans: (
                        <div>
                            Go to Profile from the bottom-right corner and tap Refer & Earn. You can refer both customers and professionals.
                            <ol>
                                <li>On the Login page, click on Register button at the bottom. On the registration Page, click on “Have a Referral code”.</li>
                                <li>Enter Name, Email Address and Password, Mobile No (optional). Enter the shared referral code and click on Register.</li>
                            </ol>
                            Please note: Professionals can also follow the above mentioned steps to register themselves using a referral code.
                        </div>
                    )
                },
                
                {
                    id: 5,
                    ques: 'Will my friend receive any coins?',
                    ans: (
                        <div>
                        Yes, if you refer a customer, both of you will earn 100 Coins after your friend completes their first service.,
                        If you refer a professional, you ll earn 200 Coins after they complete their first service. The referred professional does not receive any referral coins.,
                        Coins are credited automatically once the referral conditions are met.
                        Please note: Coins are valid for 15 days from the date of credit.
                        </div>
                    )
                },
                {
                    id: 6,
                    ques: 'Where can I see my referral earnings?',
                    ans: (
                        <div>
                            After referring a friend, referral status/ earnings can be viewed in "Invited" tab on “Refer & Earn” Page.
                        </div>
                    )
                },
                {
                    id: 7,
                    ques: 'How many friends can I refer to?',
                    ans: (
                        <div>
                            There is no limitation on the number of referrals.
                        </div>
                    )
                }
    
            ],
        )

    let [faqs_chatSupport, setFaqs_chatSupport] = useState(
        [
            {
                id: 1,
                ques: 'How can I communicate with professionals?',
                ans: (
                    <div>
                        The Chat  & Call options becomes available 2 hours before your scheduled service time.

                    </div>
                )
            },
            {
                id: 2,
                ques: 'Can I chat if my booking is cancelled?',
                ans: (
                    <div>
                        The Chat feature will let you talk to your professionals for all upcoming bookings only. When the service is cancelled or completed, you cannot communicate with them.
                    </div>
                )
            },
            {
                id: 3,
                ques: 'Where can I find the Chat & Call options?',
                ans: (
                    <div>
                        The Chat and Call options become available 2 hours before your scheduled service time. To access them, go to My Bookings → Upcoming, open your booking, and you ll find the professionals name, along with the Call and Chat options at the top of the Booking Details page.
                    </div>
                )
            },
            {
                id: 4,
                ques: 'Where can I see my notifications/messages received from professionals?',
                ans: (
                    <div>
                        You can follow below mentioned process to view/respond to the chat -
                        <ol>
                            <li>You will be notified when you receive a message from any Professional. Press on the “bell icon” in Home Page to check/respond to any message that you have received.</li>
                            <li>Or else click on any booking under the “Upcoming” tab in “My Booking page”, you will find the chat icon at the bottom of the page with new notifications count.</li>
                            <li>Tap on the icon to view new messages or communicate with the professional.</li>
                        </ol>

                    </div>
                )
            },
            {
                id: 5,
                ques: 'How can I provide a rating for the service provided by the professional?',
                ans: (
                    <div>
                        To provide rating to your professional, follow the below steps -
                        <ol type="a">

                            <li> Visit your Profile and click on “My bookings”.</li>
                            <li> Select any booking in the “Past” tab.</li>
                            <li>At the bottom of booking display card you will find ratings.</li>
                            <li>You can give 0-5 star rating to any professional for completed booking (i.e. after service delivery and booking validation).</li>
                        </ol>

                    </div>
                )
            },
            {
                id: 6,
                ques: 'Is it mandatory to provide a rating?',
                ans: (
                    <div>
                        Ratings are not mandatory, but we strongly request your rating to help us understand the quality of service provided to you, so that we can serve you better.

                    </div>
                )
            },
            {
                id: 7,
                ques: 'Where can I learn more about the Slash app?',
                ans: (
                    <div>
                        To know more about Slash app you can click on “A Guide to slash” on the login page or you can follow below mentioned steps-
                        <ol>
                            <li>Go to your Profile Page.</li>
                            <li>Click on “A Guide to Slash” to know more about Slash and view demo videos on details of various features.</li>
                        </ol>
                    </div>
                )
            },
            {
                id: 8,
                ques: ' How can I reach Slash support?',
                ans: 'contact'
            }

        ],
    )
    let [collapse_Consumer1, setCollapse_Consumer1] = useState({})
    const [prevId, setPrevId] = useState()
    let [show, setShow] = useState(5)
    let [docs, setDocs] = useState('Profile & Registration')
    const [activeItem, setActiveItem] = useState('Profile & Registration');
    const navItem = ['Profile & Registration', 'Booking & Cancellations', 'Payments & Refunds', 'Referrals', "Chat & Support"]
    const [selectedView, setSelectedView] = useState(0)
    const faqCollapseHandlerC1 = (id) => {
        let collapse_Consumer = {};
        console.log('id', id)
        if (collapse_Consumer1['collapse_' + id]) {
            collapse_Consumer = {
                ...collapse_Consumer1,
                ['collapse_' + id]: false
            }
            setCollapse_Consumer1(collapse_Consumer)
        } else {
            collapse_Consumer = {
                ...collapse_Consumer1,
                // ['collapse_' + prevId]: false,
                ['collapse_' + id]: true,
            }
            setCollapse_Consumer1(collapse_Consumer)
        }
    }

    function handleItemClick(item) {
        setActiveItem(item);
    }
    const profileHandler = () => {
        let collapse_Consumer = {};

        collapse_Consumer = {
            ...collapse_Consumer1,
            ['collapse_' + prevId]: false
        }
        setShow(5)
        setCollapse_Consumer1(collapse_Consumer)
        setDocs('Profile')
    }

    const bookingsHandler = () => {
        let collapse_Consumer = {};

        collapse_Consumer = {
            ...collapse_Consumer1,
            ['collapse_' + prevId]: false
        }
        setShow(5)
        setCollapse_Consumer1(collapse_Consumer)
        setDocs('Booking')
    }
    const paymentHandler = () => {
        let collapse_Consumer = {};

        collapse_Consumer = {
            ...collapse_Consumer1,
            ['collapse_' + prevId]: false
        }
        setShow(5)
        setCollapse_Consumer1(collapse_Consumer)
        setDocs('Payments')
    }
    const couponsHandler = () => {
        let collapse_Consumer = {};

        collapse_Consumer = {
            ...collapse_Consumer1,
            ['collapse_' + prevId]: false
        }
        setShow(5)
        setCollapse_Consumer1(collapse_Consumer)
        setDocs('Coupon')
    }
    const chatHandler = () => {
        let collapse_Consumer = {};

        collapse_Consumer = {
            ...collapse_Consumer1,
            ['collapse_' + prevId]: false
        }
        setShow(5)
        setCollapse_Consumer1(collapse_Consumer)
        setDocs('Support')
    }


    const showMore = () => {

        // this.setState({show: this.state.show+5})
        setShow(show = show + 5)
    }

    const showLess = () => {
        // this.setState({show: this.state.show-5})
        setShow(show = show - 5)
    }

    const renderSupportContact = () => {
        console.log('state2', state)
        let phone='+91 8977509988'
        const isUs = state && state.address && state.address.country !== 'India';
         phone = isUs ? '+1 650-739-8103':'+91 8977509988' ;
        return (
            <div>
                You can email us to our email address support@goslash.com or call us on our number {phone}.
            </div>
        )
    }


    let FAQ_Profile;


    if (faqs_profileRegistration.length !== 0) {

        FAQ_Profile = faqs_profileRegistration.slice(0, show).map((ques, i) => {
            return (
                <div style={{ transition: 'opacity 0.3s ease', display: 'block' }}>
                    <div className='question' style={{ transition: 'opacity 0.3s ease', display: 'flex', flexDirection: 'row' }}>

                        <div style={{ cursor: 'pointer', width: '95%', paddingBottom: 10 }} onClick={() => faqCollapseHandlerC1(ques.id)}>
                            <CardText className='questionText'> {ques.ques} </CardText>
                        </div>
                        <div style={{ cursor: 'pointer', width: '5%' }} onClick={() => faqCollapseHandlerC1(ques.id)}>
                            {collapse_Consumer1['collapse_' + ques.id] ?
                                <img src={upArrow} width={15} />
                                :
                                <img src={downArrow} width={15} />
                            }
                        </div>
                    </div>
                    {/* :
                                <Col sm={{size:'auto'}} style={{cursor:'pointer'}} onClick={() => this.faqCollapseHandlerC1(ques.id)}>                            
                                </Col> */}
                    {/* </Row>  */}
                    {/* <Row> */}
                    <div className='ansdiv'>
                        <Collapse isOpen={collapse_Consumer1['collapse_' + ques.id]} style={{ width: '95%' ,padding:20}}>
                            <CardText style={{ fontFamily: "Mulish", fontSize: 14, fontWeight: "normal", fontStyle: "normal", lineHeight: 'normal', letterSpacing: 0, color: "#7e757e" }} >{ques.ans}</CardText>
                        </Collapse>
                    </div>
                    {/* </Row>                      */}
                    {show == i + 1 || faqs_profileRegistration.length == i + 1 ? null : <div style={{ marginTop: 10 }}></div>}

                </div>

            )
        })
    }


    let FAQ_Booking;


    if (faqs_bookingCancellation.length !== 0) {

        FAQ_Booking = faqs_bookingCancellation.slice(0, show).map((ques, i) => {
            return (
                <div style={{ transition: 'opacity 0.3s ease', display: 'block' }}>
                    <div className='question' style={{ transition: 'opacity 0.3s ease', display: 'flex', flexDirection: 'row' }}>

                        <div style={{ cursor: 'pointer', width: '95%' }} onClick={() => faqCollapseHandlerC1(ques.id)}>
                            <CardText className='questionText'> {ques.ques} </CardText>
                        </div>
                        <div style={{ cursor: 'pointer', width: '5%' }} onClick={() => faqCollapseHandlerC1(ques.id)}>
                            {collapse_Consumer1['collapse_' + ques.id] ?
                                <img src={upArrow} width={15} />
                                :
                                <img src={downArrow} width={15} />
                            }
                        </div>
                    </div>
                    {/* :
                                    <Col sm={{size:'auto'}} style={{cursor:'pointer'}} onClick={() => this.faqCollapseHandlerC1(ques.id)}>                            
                                    </Col> */}
                    {/* </Row>  */}
                    {/* <Row> */}
                    <div className='ansdiv'>
                        <Collapse isOpen={collapse_Consumer1['collapse_' + ques.id]} style={{ width: '95%',padding:20 }}>
                            <CardText style={{ fontFamily: "Mulish", fontSize: 14, fontWeight: "normal", fontStyle: "normal", lineHeight: 'normal', letterSpacing: 0, color: "#7e757e" }} >{ques.ans}</CardText>
                        </Collapse>
                    </div>
                    {/* </Row>                      */}
                    {show == i + 1 || faqs_bookingCancellation.length == i + 1 ? null : <div style={{ marginTop: 10 }}></div>}

                </div>

            )
        })
    }


    let FAQ_Payment;


    if (faqs_paymentRefund.length !== 0) {

        FAQ_Payment = faqs_paymentRefund.slice(0, show).map((ques, i) => {
            return (
                <div style={{ transition: 'opacity 0.3s ease', display: 'block' }}>
                    <div className='question' style={{ transition: 'opacity 0.3s ease', display: 'flex', flexDirection: 'row' }}>

                        <div style={{ cursor: 'pointer', width: '95%' }} onClick={() => faqCollapseHandlerC1(ques.id)}>
                            <CardText className='questionText'> {ques.ques} </CardText>
                        </div>
                        <div style={{ cursor: 'pointer', width: '5%' }} onClick={() => faqCollapseHandlerC1(ques.id)}>
                            {collapse_Consumer1['collapse_' + ques.id] ?
                                <img src={upArrow} width={15} />
                                :
                                <img src={downArrow} width={15} />
                            }
                        </div>
                    </div>
                    {/* :
                                <Col sm={{size:'auto'}} style={{cursor:'pointer'}} onClick={() => this.faqCollapseHandlerC1(ques.id)}>                            
                                </Col> */}
                    {/* </Row>  */}
                    {/* <Row> */}
                    <div className='ansdiv'>
                        <Collapse isOpen={collapse_Consumer1['collapse_' + ques.id]} style={{ width: '95%',padding:20 }}>
                            <CardText style={{ fontFamily: "Mulish", fontSize: 14, fontWeight: "normal", fontStyle: "normal", lineHeight: 'normal', letterSpacing: 0, color: "#7e757e" }} >{ques.ans}</CardText>
                        </Collapse>
                    </div>
                    {/* </Row>                      */}
                    {show == i + 1 || faqs_paymentRefund.length == i + 1 ? null : <div style={{ marginTop: 10 }}></div>}

                </div>

            )
        })
    }


    let FAQ_Refer;


    if (faqs_couponReferral.length !== 0) {

        FAQ_Refer = faqs_couponReferral.slice(0, show).map((ques, i) => {
            return (
                <div style={{ transition: 'opacity 0.3s ease', display: 'block' }}>
                    <div className='question' style={{ transition: 'opacity 0.3s ease', display: 'flex', flexDirection: 'row' }}>

                        <div style={{ cursor: 'pointer', width: '95%' }} onClick={() => faqCollapseHandlerC1(ques.id)}>
                            <CardText className='questionText'> {ques.ques} </CardText>
                        </div>
                        <div style={{ cursor: 'pointer', width: '5%' }} onClick={() => faqCollapseHandlerC1(ques.id)}>
                            {collapse_Consumer1['collapse_' + ques.id] ?
                                <img src={upArrow} width={15} />
                                :
                                <img src={downArrow} width={15} />
                            }
                        </div>
                    </div>
                    {/* :
                                    <Col sm={{size:'auto'}} style={{cursor:'pointer'}} onClick={() => this.faqCollapseHandlerC1(ques.id)}>                            
                                    </Col> */}
                    {/* </Row>  */}
                    {/* <Row> */}
                    <div className='ansdiv'>
                        <Collapse isOpen={collapse_Consumer1['collapse_' + ques.id]} style={{ width: '95%' ,padding:20}}>
                            <CardText style={{ fontFamily: "Mulish", fontSize: 14, fontWeight: "normal", fontStyle: "normal", lineHeight: 'normal', letterSpacing: 0, color: "#7e757e" }} >{ques.ans}</CardText>
                        </Collapse>
                    </div>
                    {/* </Row>                      */}
                    {show == i + 1 || faqs_couponReferral.length == i + 1 ? null : <div style={{ marginTop: 10 }}></div>}

                </div>

            )
        })
    }


    let FAQ_Support;


    if (faqs_chatSupport.length !== 0) {

        FAQ_Support = faqs_chatSupport.slice(0, show).map((ques, i) => {
            return (
                <div style={{ transition: 'opacity 0.3s ease', display: 'block' }}>
                    <div className='question' style={{ transition: 'opacity 0.3s ease', display: 'flex', flexDirection: 'row' }}>

                        <div style={{ cursor: 'pointer', width: '95%' }} onClick={() => faqCollapseHandlerC1(ques.id)}>
                            <CardText className='questionText'> {ques.ques} </CardText>
                        </div>
                        <div style={{ cursor: 'pointer', width: '5%' }} onClick={() => faqCollapseHandlerC1(ques.id)}>
                            {collapse_Consumer1['collapse_' + ques.id] ?
                                <img src={upArrow} width={15} />
                                :
                                <img src={downArrow} width={15} />
                            }
                        </div>
                    </div>
                    {/* :
                                        <Col sm={{size:'auto'}} style={{cursor:'pointer'}} onClick={() => this.faqCollapseHandlerC1(ques.id)}>                            
                                        </Col> */}
                    {/* </Row>  */}
                    {/* <Row> */}
                    <div className='ansdiv'>
                        <Collapse isOpen={collapse_Consumer1['collapse_' + ques.id]} style={{ width: '95%' ,padding:20}}>
                            <CardText style={{ fontFamily: "Mulish", fontSize: 14, fontWeight: "normal", fontStyle: "normal", lineHeight: 'normal', letterSpacing: 0, color: "#7e757e" }} >{ques.ans === 'contact' ? renderSupportContact() : ques.ans}</CardText>
                        </Collapse>
                    </div>
                    {/* </Row>                      */}
                    {show == i + 1 || faqs_chatSupport.length == i + 1 ? null : <div style={{ marginTop: 10 }}></div>}

                </div>

            )
        })
    }
    let activeStyleForSelection = {
        color: '#8c52ff',
        fontFamily: 'Inter',
        fontSize: '14px',
        fontWeight: 600,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        borderBottom: '1.5px solid #8c52ff',
        paddingBottom: 10,
    }
    const sectionSelection = (value) => {
        setSelectedView(value)
    }

    let sectionsHeader;
    if (navItem.length !== 0) {
        sectionsHeader = (
            // <div style={{position:'absolute',left:'auto',}}>
            <div className='faqScrool'>
                {
                    navItem.map((item, index) => {
                        return (
                            <div style={{ marginTop: 15, marginBottom: 15, marginLeft: 20, marginRight: 20 }}>
                                <text className={item === activeItem ? "mybooking_navbarItem_active_style1" : "mybooking_navbarItem_style1"} onClick={() => handleItemClick(item)} >{item}</text>
                            </div>
                        )

                    })
                }
            </div>
            // </div>
        )
    }

    console.log('navitem',navItem)
    return (
        <div style={{ paddingBottom:20 }}>

            {/* <Nav tabs className="mybooking_navbar_style1" style={{overflowX:'scroll',flexWrap:'nowrap' }}>
                {navItem.map((item) => (
                    <NavItem  className={item === activeItem ? "mybooking_navbarItem_active_style1" : "mybooking_navbarItem_style1"} style={{overflowX:'scroll'}}>
                        <NavLink key={item} onClick={() => handleItemClick(item)}  >{item}</NavLink>
                    </NavItem>
                ))}
            </Nav> */}


            {/* <Card style={{height:200,width:200,overflow:'scroll',paddingLeft:28,paddingTop:16,backgroundColor:'white'}}> */}
            <div style={{cursor:'pointer'}}>
                {sectionsHeader}
            </div>
            {/* </Card> */}
            <div style={{ padding: 0, display: 'flex', justifyContent: 'center' }}>
                <div style={{ padding: 10, textAlign: 'left', width: '100%' }}>
                    {activeItem == 'Profile & Registration' ? FAQ_Profile : null}
                    {activeItem == 'Booking & Cancellations' ? FAQ_Booking : null}
                    {activeItem == 'Payments & Refunds' ? FAQ_Payment : null}
                    {activeItem == 'Referrals' ? FAQ_Refer : null}
                    {activeItem == 'Chat & Support' ? FAQ_Support : null}
                </div>



            </div>
            {show <= 5 ?

<div className='showMore' onClick={() => showMore()}>
    <text style={{ textDecorationLine: 'underline', color: '#461c99' }}>Show More</text>
    {/* <img src={downArrow} width={15} /> */}
</div>

: show >= faqs_profileRegistration.length && docs == 'Profile' ?
    <div className='showMore' onClick={() => showLess()}>
        <text style={{ textDecorationLine: 'underline', color: '#461c99' }}>Show Less</text>
        {/* <img src={upArrow} width={15} /> */}
    </div>

    : show >= faqs_bookingCancellation.length && docs == 'Booking' ?
        <div className='showMore' onClick={() => showLess()}>
            <text style={{ textDecorationLine: 'underline', color: '#461c99' }}>Show Less</text>
            {/* <img src={upArrow} width={15} /> */}
        </div>

        : show >= faqs_paymentRefund.length && docs == 'Payments' ?
            <div className='showMore' onClick={() => showLess()}>
                <text style={{ textDecorationLine: 'underline', color: '#461c99' }}>Show Less</text>
                {/* <img src={upArrow} width={15} /> */}
            </div>

            : show >= faqs_couponReferral.length && docs == 'Coupon' ?
                <div className='showMore' onClick={() => showLess()}>
                    <text style={{ textDecorationLine: 'underline', color: '#461c99' }}>Show Less</text>
                    {/* <img src={upArrow} width={15} /> */}
                </div>

                : show >= faqs_chatSupport.length && docs == 'Support' ?
                    <div className='showMore' onClick={() => showLess()}>
                        <text style={{ textDecorationLine: 'underline', color: '#461c99' }}>Show Less</text>
                        {/* <img src={upArrow} width={15} /> */}
                    </div>

                    :
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', width: 400, marginRight: 'auto', marginLeft: 'auto' }}>
                        {/* <div className='showMore' onClick={() => showMore()}>
                            <text style={{ textDecorationLine: 'underline', color: '#461c99' }}>Show More</text>
                           
                        </div> */}
                        <div className='showMore' onClick={() => showLess()}>
                            <text style={{ textDecorationLine: 'underline', color: '#461c99' }}>Show Less</text>
                           
                        </div>
                    </div>
}

        </div>
    );
}

export default FaqConsumerMobile;
